import { OrderItem } from '@libs/api-reference';

import { ALGORITHM_ORDER_TYPES } from '../constants';

const isAlgorithmOrder = (order: OrderItem) =>
  ALGORITHM_ORDER_TYPES.includes(order.orderType);

export { isAlgorithmOrder };
